import bummedDataPolicy from './DataPolicy/flow';

const bummedFlows = {
  bummedDataPolicy
};

export default bummedFlows;
